import axios from 'axios';
import { getAuthHeaders } from './authUtils';
import { config } from '../constants';

const API_BASE = config.API_BASE_URL;

class TwoFactorServiceClass {
    /**
     * Check current 2FA status for the logged-in user.
     */
    async getStatus() {
        const headers = getAuthHeaders();
        return await axios.get(`${API_BASE}/api/TwoFactor/status`, { headers });
    }

    /**
     * Initiate 2FA pairing (generates Base32 secret key & otpauth URI).
     */
    async setupInit() {
        const headers = getAuthHeaders();
        return await axios.post(`${API_BASE}/api/TwoFactor/setup-init`, {}, { headers });
    }

    /**
     * Confirm 2FA pairing with the 6-digit code from authenticator app.
     */
    async setupConfirm(code) {
        const headers = getAuthHeaders();
        return await axios.post(`${API_BASE}/api/TwoFactor/setup-confirm`, { code }, { headers });
    }

    /**
     * Disable 2FA. Requires current account password + 6-digit code.
     */
    async disable(password, code) {
        const headers = getAuthHeaders();
        return await axios.post(`${API_BASE}/api/TwoFactor/disable`, { password, code }, { headers });
    }

    /**
     * Step 2 login verification using 6-digit code or emergency backup code.
     */
    async verifyLogin(tempToken, code) {
        return await axios.post(`${API_BASE}/api/TwoFactor/verify-login`, { tempToken, code });
    }
}

const TwoFactorService = new TwoFactorServiceClass();
export default TwoFactorService;
